import { render } from "./FilterProfilesTemplate.vue?vue&type=template&id=78bb977a&ts=true"
import script from "./FilterProfilesTemplate.vue?vue&type=script&lang=ts"
export * from "./FilterProfilesTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__